import React, {useState, useEffect} from "react";
import { useDispatch } from 'react-redux';
import Table from "rc-table";
import {
  DeliveryInfo,
  DeliveryAddress,
  Address,
  CostCalculation,
  PriceRow,
  Price,
  ProgressWrapper,
  OrderTableWrapper,
  OrderTable,
	Reorder,
	EventWrapper
} from "./OrderDetails.style";
import Progress from "../../../../components/ProgressBox/ProgressBox";
import { CURRENCY } from "../../../../helper/constant";
import { FormattedMessage } from "react-intl";
import { Title } from "../Order.style";
import { Status } from "../OrderCard/OrderCard.style";
import t from '../../../../i18n/translate';
import SimpleMessageDialog from "../../../../components/SimpleMessageDialog/SimpleMessageDialog";
import * as actionTypes from "../../../../store/ActionTypes";
import {useCart} from "../../../../contexts/cart/use-cart";
import itemToCartService from "../../../../services/itemToCartService";
import {
	Table as MTable,
	Tooltip,
	LinearProgress,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Typography
} from '@material-ui/core';
import moment from "moment";
import LaunchIcon from '@material-ui/icons/Launch';
import colors from "../../../../theme/colors";
import RefreshIcon from '@material-ui/icons/Refresh';
import IconButton from '@material-ui/core/IconButton';
import API from "../../../../network/redAPI";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const components = {
  table: OrderTable,
};
const OrderDetails = ({
  tableData,
  columns,
  address,
  progressBox,
  progressStatus,
  subtotal,
  discount,
  deliveryFee,
  grandTotal,
  name,
  phone,
  delivery_slot,
  country_code,
  comments,
  pageType,
  status,
  onError,
  onSuccess,
  type,
  props,
	                      orderId,
	                      orderDetails
}) => {
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const lang = localStorage.getItem('lang') || 'en';
  const [errorMessage, setErrorMessage] = useState('');
  const { items } = useCart();

  const [closeLabel, setCloseLabel] = useState('');
  const [confirmLabel, setConfirmLabel] = useState('');
  const [dialogHeaderLabel, setDialogHeaderLabel] = useState(t('shop_checkout_alert_error'));
  const [simpleDialogBackdrop, setSimpleDialogBackdrop] = useState(true);
  const [isConfirmButton, setIsConfirmButton] = useState(false);
  const [isLoadingDialog, setIsLoadingDialog] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
	const [tracking, setTracking] = useState([]);
	const [trackingEvent, setTrackingEvent] = useState([]);
	const [dialogLoading, setDialogLoading] = useState(false)
	const CP_URL = process.env.REACT_APP_CP_URL

	const dispatch = useDispatch();
  const handleReOrder = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const currentOrder = props[type].find(item => item.order_id === orderId);

    const isExpressMode = props.cartType === 'express';
    setCloseLabel( t('button_close_label') );

    if(currentOrder.type && !isExpressMode) {
      setErrorMessage( t('shop_order_detail_switch_to_express_mode_message_for_reorder') )
      setShowErrorDialog(true);
    }
    else if(isExpressMode && !currentOrder.type) {
      setErrorMessage( t('shop_order_detail_switch_to_normal_mode_message_for_reorder') )
      setShowErrorDialog(true);
    }
    else {
      // If user have some items in current basket
      if(items.length) {
        setErrorMessage( t('shop_order_detail_re_order_error') );
        setConfirmLabel( t('shop_item_detail_confirm_button') );
        setCloseLabel( t('shop_tracking_order_cancel_button') );
        setIsConfirmButton(true);
        setShowErrorDialog(true);
      }
      else {
        setIsFetching(true);
        await reOrderValidator();
      }
    }
  }

  const reOrderValidator = async () => {
    if(!isFetching) {
      const dataResp = await itemToCartService.reOrder(orderId);
      if(dataResp.status === 401) {
        setErrorMessage( dataResp.data.message );
        setIsConfirmButton(false);
        setShowErrorDialog(true);
      }
      else if(dataResp.status === 400) {
        onError(dataResp.data.message);
        setShowErrorDialog(false);
      }
      else if(dataResp.status === 200) {
        if(!props.reordersuccess) {
          dispatch({
            type: actionTypes.Reorder,
            reordersuccess: true
          });
        }
        onSuccess(dataResp.data);
        setShowErrorDialog(false);
      }
      setIsFetching(false);
    }
  }

  const onConfirm = async () => {
    setIsLoadingDialog(true);
    await reOrderValidator();
    setIsLoadingDialog(false);
  }
  const closeSimpleDialog = () => {
    setShowErrorDialog(false);
    setIsConfirmButton(false);
    setIsLoadingDialog(false);
    setErrorMessage('');
    setConfirmLabel('');
    setCloseLabel('');
  }
  //goto cambodia post website
	const handleGoToWebsiteTracking = () => {
		const url = tracking?.website;
    window.open(url, "_blank");
  };

  //tracking with cp
  const handleTrackingCode = async (getType = "create") => {
	  if (!orderDetails.tracking_number) return alert("Please enter tracking code");
    setDialogLoading(true);
	  const newUrl = window.location.origin + window.location.pathname + "?tracking_code=" + encodeURIComponent(orderDetails?.tracking_number);
    window.history.replaceState(null, "", newUrl);
	  const code = orderDetails?.tracking_number.toUpperCase();
	  await API.findTrackingCode(code, {
		  orderId: orderId,
		  courierCompany: orderDetails?.courier_company,
		  getType: getType
	  })
        .then((res) => res.json())
        .then((res) => {
          if (res.success) {
	          setTrackingEvent(res.shipment.data);
            setDialogLoading(false);
          } else {
            setDialogLoading(false);
            alert(res.message);
          }
        });
  };

  useEffect(() => {
    if(props.reordersuccess || props.reordersuccess === 'error') {
      dispatch({
        type: actionTypes.Reorder,
        reordersuccess: false
      });

      closeSimpleDialog();
    }
  }, [props.reordersuccess]);
	useEffect(() => {
		setTracking(props.fetch_particular_order?.shipment_trackings[0]);
		setTrackingEvent(props.fetch_particular_order?.shipment_trackings);
	}, [props.fetch_particular_order])
  return (
    <>
      <div>
        <Title style={{ padding: "0 20px", width: "50%", display: "inline-block" }}>
          {props.fetch_particular_order?.type === 1
            ? <>{ t('shop_order_list_order_details_title') } <span style={{color: '#f01266'}}>(Express)</span></>
            : t('shop_order_list_order_details_title')
          }
        </Title>
        <div style={{padding: "0 20px", width: "50%", display: "inline-block", textAlign: "right",}}>
          {localStorage.getItem("user")
            ? <Reorder style={{cursor: "pointer", marginRight: "15px"}} onClick={handleReOrder}>{ t('shop_order_list_re_order_label') }</Reorder>
            : null
          }
          <Status>
            {typeof progressBox !== 'undefined'
              ? t(`shop_order_list_status_${ progressBox[progressStatus].replace(' ', '_').toLowerCase() }`)
              : ''
            }
          </Status>
        </div>
      </div>
      <DeliveryInfo>
        <DeliveryAddress>
          <h3>{ t('setting_shop_addresses') }</h3>
          <Address>{ t('profile_user_full_name_input_title') }:{name}</Address>
          <Address>{ t('shop_address_list_phone_abbreviation_label') }: {"+" + country_code + "-" + phone}</Address>
          <Address>
            {[
              address?.house_and_street ||
              [address?.house_number, address?.street_details].filter(Boolean).join(", "),
              address?.apartment_name,
              address?.area_details,
              address?.commune,
              address?.district,
              address?.city
            ]
                .filter(Boolean)
                .join(", ")}
          </Address>

        </DeliveryAddress>

        <DeliveryAddress>
          <h3>{ t('shop_order_list_delivery_slot_label') }</h3>
          <Address>{delivery_slot}</Address>
          {comments ? (
            <>
              <h3 className="mt-2">{ t('shop_order_list_comment_label') }</h3>
              <Address>{comments}</Address>
            </>
          ) : null}
        </DeliveryAddress>

        <CostCalculation>
          <PriceRow>
            { t('shop_checkout_subtotal') }
            <Price>
              {CURRENCY}
              {parseFloat(subtotal).toFixed(2)}
            </Price>
          </PriceRow>
          <PriceRow>
            { t('shop_checkout_delivery') }
            <Price>
              {CURRENCY}
              {parseFloat(deliveryFee).toFixed(2)}
            </Price>
          </PriceRow>
	        {props.fetch_particular_order?.driver_tip > 0
            ? <PriceRow>
			        Driver Tip
              <Price>
                {CURRENCY}
	              {parseFloat(props.fetch_particular_order?.driver_tip).toFixed(2)}
              </Price>
		        </PriceRow>
		        : null
	        }
	        {props.fetch_particular_order?.coupon_discount_amount > 0
		        ? <PriceRow>
			        {t('shop_checkout_discount')}
			        <Price style={{color: '#dc3545'}}>
				        -{CURRENCY}
	              {parseFloat(props.fetch_particular_order?.coupon_discount_amount).toFixed(2)}
              </Price>
            </PriceRow>
            : null
          }
          <PriceRow className="grandTotal">
            { t('shop_checkout_grand_total') }
            <Price>
              {CURRENCY}
              {(() => {
                // Use order_total from order_payment_summery or fall back to order_total from details
                const orderTotal = props.fetch_particular_order?.order_payment_summery?.order_total
                  || props.fetch_particular_order?.order_total
                  || 0;
                return parseFloat(orderTotal).toFixed(2);
              })()}
            </Price>
          </PriceRow>
	        {(() => {
            // Check wallet amount from both new and old data sources
            const walletAmount = props.fetch_particular_order?.order_payment_summery?.already_paid_amount
              || props.fetch_particular_order?.wallet_payment
              || 0;

            return walletAmount > 0 ? (
              <PriceRow>
                { t('shop_checkout_wallet') }
                <Price style={{color: '#1976d2'}}>
                  -{CURRENCY}
                  {parseFloat(walletAmount).toFixed(2)}
                </Price>
              </PriceRow>
            ) : null;
          })()}
	        {(() => {
            // Check delipoint amount from both new and old data sources
            const delipointAmount = props.fetch_particular_order?.dp_discount_payment
              || 0;
            
            // console.log("delipointAmount:", delipointAmount); // Debug log to check wallet amount

            return delipointAmount > 0 ? (
              <PriceRow>
                { t('shop_checkout_delipoints') }
                <Price style={{color: '#1976d2'}}>
                  -{CURRENCY}
                  {parseFloat(delipointAmount).toFixed(2)}
                </Price>
              </PriceRow>
            ) : null;
          })()}
          <PriceRow style={{borderTop: '1px solid #e0e0e0', paddingTop: '8px', marginTop: '8px'}}>
            Remaining Amount
            <Price style={{color: '#2e7d32', fontWeight: 'bold'}}>
              {CURRENCY}
              {(() => {
	              const order = props.fetch_particular_order;
	              // Use remaining_amount from order_payment_summery or calculate from order_payment_details
	              const remainingAmount =
		              order?.order_payment_summery?.remaining_amount ??
		              (order?.payment_method_name !== "Paid online"
			              ? order?.order_payment_details?.[0]?.amount
			              : 0);
                return parseFloat(remainingAmount).toFixed(2);
              })()}
            </Price>
          </PriceRow>
        </CostCalculation>
      </DeliveryInfo>

      {/*Order Stepper Status*/}
	    <>
		    <ProgressWrapper>
			    <Progress data={progressBox}
			              status={progressStatus}
			              cartType={props.fetch_particular_order?.type === 1
				              ? 'express'
				              : 'normal'
			              }
			    />
		    </ProgressWrapper>
		    {props.fetch_particular_order?.status > 2 && trackingEvent.length > 0 &&
			    <EventWrapper>
				    <Row className="d-flex mt-1 ml-2 align-items-center">
					    <Typography
						    variant="subtitle1"
						    className="text-uppercase font-weight-bold mb-0 mr-3"
					    >
						    Shipment Tracking
					    </Typography>

					    {trackingEvent && orderDetails?.courier_company && (
						    <div
							    style={{
								    display: 'flex',
								    alignItems: 'center',
								    backgroundColor: '#f8f9fa',
								    borderRadius: 20,
								    padding: '6px 12px',
								    boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
							    }}
						    >
							    {/* Courier company name */}
							    <Typography
								    variant="body2"
								    style={{
									    fontWeight: 600,
									    whiteSpace: 'nowrap',
									    marginRight: 8,
									    color: colors.darkBlue,
								    }}
							    >
								    {orderDetails?.courier_company}
							    </Typography>

							    {/* Tracking code link */}
							    <Tooltip title={`Go to ${orderDetails?.courier_company} website`}>
					        <span style={{marginRight: 8}}>
					          <Typography
						          component="span"
						          variant="body2"
						          style={{fontWeight: 500, marginRight: 4}}
					          >
					            Tracking:
					          </Typography>
					          <a
						          onClick={
							          trackingEvent[0]?.allow_open_website
								          ? handleGoToWebsiteTracking
								          : undefined
						          }
						          style={{
							          cursor: trackingEvent[0]?.allow_open_website
								          ? 'pointer'
								          : 'default',
							          textDecoration: trackingEvent[0]?.allow_open_website
								          ? 'underline'
								          : 'none',
							          color: trackingEvent[0]?.allow_open_website
								          ? colors.blue
								          : colors.textPrimary,
							          fontWeight: 500,
						          }}
					          >
					            {orderDetails?.tracking_number}{' '}
						          <LaunchIcon
							          style={{
								          color: trackingEvent[0]?.allow_open_website
									          ? colors.blue
									          : colors.darkBlue,
								          fontSize: 16,
								          verticalAlign: 'middle',
							          }}
						          />
					          </a>
					        </span>
							    </Tooltip>

							    {/* Refresh button */}
							    <Tooltip title="Refresh tracking data">
								    <IconButton
									    onClick={() => handleTrackingCode('create')}
									    aria-label="refresh tracking"
									    size="small"
									    style={{
										    padding: 4,
										    marginLeft: 4,
										    backgroundColor: colors.lightGray,
										    borderRadius: '50%',
									    }}
								    >
									    <RefreshIcon fontSize="small" style={{color: colors.blue}}/>
								    </IconButton>
							    </Tooltip>
						    </div>
					    )}
				    </Row>
				    {dialogLoading && <Col>
					    <LinearProgress style={{backgroundColor: colors.darkRegular}}/>
				    </Col>}
				    <MTable aria-label="simple table" className={"my-1"}>
					    <TableHead>
						    <TableRow className={"text-uppercase font-weight-bold"}>
							    <TableCell align="left">Event date</TableCell>
							    <TableCell align="left">Display description</TableCell>
						    </TableRow>
					    </TableHead>

					    <TableBody>
						    {trackingEvent
							    .slice()
							    .sort((a, b) => a?.status_code.localeCompare(b?.status_code)) // Sort lexicographically
							    .map((row, idx) => (
								    <TableRow key={row.name}>
									    <TableCell align="left">{moment(row?.event_date).format('YYYY-MM-DD HH:mm')}</TableCell>
									    <TableCell align="left">{row?.display_description || "N/A"}</TableCell>
								    </TableRow>
							    ))
						    }
					    </TableBody>
				    </MTable>
			    </EventWrapper>
		    }
	    </>

      <OrderTableWrapper>
        <Table
          columns={columns}
          data={tableData}
          rowKey={(record) => record.order_item_id}
          components={components}
          className={`orderDetailsTable ${props.fetch_particular_order?.type === 1
            ? 'express'
            : 'normal'
          }`}
          // scroll={{ y: 350 }}
        />
      </OrderTableWrapper>

      <SimpleMessageDialog show={showErrorDialog}
                           message={errorMessage}
                           showHeader={true}
                           closeLabel={closeLabel}
                           confirmLabel={confirmLabel}
                           headerLabel={dialogHeaderLabel}
                           isConfirmButton={isConfirmButton}
                           onClose={closeSimpleDialog}
                           onConfirm={onConfirm}
                           loading={isLoadingDialog}
                           backdrop={simpleDialogBackdrop}
                           cartType={props.cartType}
      />
    </>
  );
};

OrderDetails.defaultProps = {
  delivery_slot: null,
}

export default OrderDetails;
